import React from "react";
import { Box, Typography, styled, useTheme, useMediaQuery } from "@material-ui/core";
import { Product } from "../../../../../types/product";
import useRepairBonusAmount from "../../../../../hooks/useRepairBonusAmount";
import InformationDrawer from "../../../../design-system/molecules/InformationDrawer";
import RepairBonusDrawerContent from "../../../../design-system/organisms/RepairBonusDrawer/RepairBonusDrawerContent";

interface StepperFunnelFooterProps {
  amount: number;
  products: Product[];
  displayBonusAdditionalInfos: boolean;
}

const StyledTypographyPrice = styled(Typography)(({ theme }) => ({
  fontSize: 26,
  fontWeight: 700,
  color: theme.palette.secondary.dark,
}));

const StyledTypographyTotal = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 500,
  color: theme.palette.secondary.dark,
}));

const StyledBonusInfos = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.turquoise,
  textAlign: "right",
  fontSize: "13px",
  lineHeight: "18px",
}));

export const StyledGreyRectangle = styled("div")(({ theme }) => ({
  width: "87px",
  height: "34px",
  borderRadius: "4px",
  backgroundColor: theme.palette.grey200.main,
}));

const BonusDrawerForSidebar = () => {
  const theme = useTheme();
  const isUnderSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <InformationDrawer
      anchor={isUnderSmallScreen ? "bottom" : "right"}
      width={isUnderSmallScreen ? "100%" : "470px"}
      title="À propos du Bonus Réparation"
      button={
        <Box textAlign="right">
          <StyledBonusInfos>
            <u>Voir les conditions</u>
          </StyledBonusInfos>
        </Box>
      }
    >
      {() => <RepairBonusDrawerContent />}
    </InformationDrawer>
  );
};

const StepperFunnelFooter: React.FC<StepperFunnelFooterProps> = ({
  children,
  amount,
  products,
  displayBonusAdditionalInfos,
}) => {
  const bonus = useRepairBonusAmount(products) / 100;
  return (
    <>
      {children}
      <Box display="flex" justifyContent="space-between" alignItems="center" marginTop={2} marginBottom={2}>
        <StyledTypographyTotal>Total</StyledTypographyTotal>
        {displayBonusAdditionalInfos ? (
          <StyledTypographyPrice>{amount + bonus},00€</StyledTypographyPrice>
        ) : (
          <StyledGreyRectangle />
        )}
      </Box>
      {displayBonusAdditionalInfos && bonus !== 0 && (
        <Box>
          <StyledBonusInfos>
            après <b>Bonus Réparation</b>
          </StyledBonusInfos>
          <BonusDrawerForSidebar />
        </Box>
      )}
    </>
  );
};

export default StepperFunnelFooter;
